import './assets/main.scss'
import 'vue3-perfect-scrollbar/style.css'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './onenetwork/router'
import { i18n } from '@/plugins/i18n.ts'
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar'
import axiosPlugin from '@/plugins/axios.ts'
import PrimeVue from 'primevue/config'
import VueApexCharts from "vue3-apexcharts";
import UUID from 'vue3-uuid'
import clickOutside from '@/onenetwork/directives/clickOutside.ts'
import piniaPersist from 'pinia-plugin-persistedstate'
import ConfirmationService from 'primevue/confirmationservice';
import { useAuthStore } from './onenetwork/stores/onenetwork.store.auth'
import { setToken } from './onenetwork/core/onenetwork.api.instant'

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App)
app.use(axiosPlugin)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(UUID)
app.use(ConfirmationService);
app.use(ToastService)
app.use(VueApexCharts);

//get and set token from useAuthStore
const authStore = useAuthStore()

setToken(authStore?.accessToken || '')
authStore.fetchMe()

const __APP_CURRENT_VERSION = localStorage.getItem('__on_bo_version') || ""
if(!__APP_CURRENT_VERSION) {
  localStorage.setItem('__on_bo_version', __APP_VERSION__)
}
if(__APP_CURRENT_VERSION !== __APP_VERSION__) {
  localStorage.clear()
  localStorage.setItem('__on_bo_version', __APP_VERSION__)
  window.location.reload()
}



app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      cssLayer: false,
      darkModeSelector: false || 'none',
    },
  },
  locale: {
    firstDayOfWeek: 1,
    dayNames: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
    dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dayNamesMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    monthNames: [
      'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
      'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'
    ],
    monthNamesShort: [
      'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
      'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'
    ],
    today: 'Hôm nay',
    clear: 'Xoá',
    dateFormat: 'dd/mm/yy',
  }
})
app.use(PerfectScrollbarPlugin, {
  componentName: 'Scrollbar',
})
app.directive('click-outside', clickOutside)

app.mount('#onenetwork-app')

